import React, { useState } from "react";
import { Fab, Zoom, Modal, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faHome,
  faCalculator,
  faStickyNote,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import CalculatorModal from "../common/CalculatorModal.jsx";

const FloatingMenu = () => {
  const [open, setOpen] = useState(false);
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpen(false);
  };

  const openCalculator = () => {
    setCalculatorOpen(true);
  };

  const closeCalculator = () => {
    setCalculatorOpen(false);
  };

  const openNotes = () => {
    window.open("https://www.google.com/keep/", "_blank");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
    >
      <Zoom in={open}>
        <Fab
          color="secondary"
          onClick={openCalculator}
          style={{
            position: "absolute",
            bottom: 70,
            right: 0,
            zIndex: 999,
          }}
        >
          <FontAwesomeIcon icon={faCalculator} />
        </Fab>
      </Zoom>

      <Zoom in={open}>
        <Fab
          color="secondary"
          onClick={openNotes}
          style={{
            position: "absolute",
            bottom: 130,
            right: 0,
            zIndex: 999,
          }}
        >
          <FontAwesomeIcon icon={faStickyNote} />
        </Fab>
      </Zoom>

      <Zoom in={open}>
        <Fab
          color="secondary"
          onClick={() => handleNavigation("/dashboard")}
          style={{
            position: "absolute",
            bottom: 190,
            right: 0,
            zIndex: 999,
          }}
        >
          <FontAwesomeIcon icon={faHome} />
        </Fab>
      </Zoom>

      <Fab
        color="primary"
        aria-label="add"
        onClick={handleToggle}
        style={{ zIndex: 1000 }}
      >
        <FontAwesomeIcon icon={faPlus} />
      </Fab>

      <Modal
        open={calculatorOpen}
        onClose={closeCalculator}
        aria-labelledby="calculator-modal"
        aria-describedby="simple-modal-description"
      >
        <Box
          component="div"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            width: "300px",
            textAlign: "center",
          }}
        >
          <h2>Calculator</h2>
          <CalculatorModal open={calculatorOpen} onClose={closeCalculator} />
        </Box>
      </Modal>
    </div>
  );
};

export default FloatingMenu;
